export enum EnvironmentFields {
  weatherTemperature = 'weatherTemperature',
  weatherTypes = 'weatherTypes',
}
